<template>
    <div class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-[70]">
        <div class="absolute w-full h-full bg-gray opacity-50" @click="closeModal"></div>

        <div class="absolute max-h-full">
            <div class="container bg-white rounded-lg">

                <div class="max-h-full px-5 py-5">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

const emit = defineEmits(["close"]);

function closeModal() {
    emit('close')
}
</script>
